module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER-",
    attrs: {
      "id": "ucQkq79jTU5wMbxkZkoevGE",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "uIFB4HZZV3CV5YB22eMVXPE"
    }
  }), _vm._v("Other people")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "italics"
  }, [_vm._v("D.P.E. Archangel, Over Highland")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("Timberwolf Valez was nothing like other people. He never had been. He was comfortable with killing but wasn’t bloodthirsty. He had dozens of confirmed kills on the books from his days in the A.C. infantry and special forces, but that didn’t keep him up at night. He had the useful ability to calculate threats, take them out, and move on.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He had been recruited into the Department of Peace Enforcement (D.P.E.) as a special operative, helping to enforce the department’s mantra of "), _c('a', {
    attrs: {
      "id": "u4xl2wUHurqYCcsvASVY3n6"
    }
  }), _vm._v("Pax Pro Pretium - "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Peace at Any Cost.")]), _vm._v(" Essentially halting the aggressive expansion of humanity into the galaxy.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For over a hundred years, it had been a non-stop march, one war after another. Acquiring new worlds and resources. Driving dozens of species to near extinction. But the devastating losses at Arnock Prime had been a wake-up call. Beyond the sting of the casualties, a malaise fell over those in the highest reaches of government, and a dark question metastasized. Might there be other, even more powerful enemies waiting for humanity in the dark of space? The D.P.E. removed the zealots and the warmongers in order to break the cycle of endless conflict. Usually, intimidation and blackmail were enough, but operators like Timberwolf stepped in when things needed to get more hands-on.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can probably break out of here,” he called to those he knew were listening. He rose from the cot attached to the wall of his confinement cell and looked through a window in the door. The cruiser "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Archangel ")]), _vm._v("buzzed with activity, and for the moment, no one paid him any mind. They circled the world of Highland, home to the previously hidden "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("Highland Industrial Defense Park, LLC")]), _vm._v(". “You know I can!” he taunted with faux intensity.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He didn’t rage at the door or try to pick the electronic lock. He felt a peculiar sense of calm, considering how royally he had screwed up. Highland was in ruins, dripping with radiation. It had fallen to none of the three parties that had vied for it. Not the D.P.E., not the Assault Corps, and not the Arnock.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It had fallen to Timberwolf, personally.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Right before it had been destroyed, Penny, the A.I. that ran the place, had given it to him. She was an emotionally mature entity, but helplessly naïve. Why had she offered it to him with all the demons she knew plagued him? She had seen his pain, the internal agony, the awful alien Arnock presence that, until just hours before, had ridden along in his mind. "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("I guess she thought I had nothing to gain?")]), _vm._v(" he considered, but however he looked at it, he couldn’t square now owning Highland lock, stock, and smoldering barrel.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A few years ago, Timberwolf had purposely been exposed to Kizik, a psychic Arnock master. An alien with the ability to invade a human’s mind. He was supposed to have been a conduit. A method to monitor the Arnock, sense their motives, understand their intentions, and ultimately help keep the peace, but it had come with an awful cost.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The grinding.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Kizik’s dreadful and insidious presence eating away at him, balancing between destroying and exploiting him. It had driven him to take any suicide mission he could find, but that had not worked out.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The worst thing had been the protection. Kizik would take Timberwolf over when his life was threatened. He would snap back afterward to bloodied bodies all around him, not knowing what had happened. With Kizik gone, his mind felt hollowed out, but untroubled. It was like living in an old, empty house that had previously been filled with familial chaos.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He tried reaching out, quieting his mind to let the presence in. He rested his head against the cold plastisteel of the wall. “Kiz?” he murmured. Kizik had reacted in the past. Sometimes the alien would reply with language, other times with emotions or flashes of colors, but nothing came. For the first time in years, Timberwolf’s mind was his alone. He imagined himself sitting in a kitchen as a breeze came in through the windows. The curtains billowed.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Timber?” someone called his name and rapped on the door, snapping him out of his pensive state. It was Dr. Tier, his boss and handler.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hey, doc,” he said. She remained safely on the other side of the door.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m back to my usual choices,” she exhaled. “You are too dangerous to live and too valuable to kill.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s nice to say,” he smiled. She sucked in her top lip. He could see the wheels turning behind her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nothing extra in your mind?” she asked, referring to Kizik’s presence.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Looks like the book has been closed on project Jackhammer,” he needled, throwing out the name of the operation that had exposed him to Kizik in the first place. Dr. Tier had conceived of and executed Jackhammer in conjunction with his former commanding officer, Emmanual Gray.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ve got news,” she huffed. “My face and name are all over the streams. The big mystery of who runs the D.P.E. is solved.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My face too?” Timberwolf asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, you’re still just a shadow,” she said. “Conrad believes that with Kizik gone, we could execute you. Is he "), _c('span', {
    staticClass: "italics"
  }, [_vm._v("really ")]), _vm._v("gone?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I would tell you that why?” he countered.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Because I can’t even have you on the list of my problems for today.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Fine, he’s gone. Emmanuel Gray is below. You’re here regarding his whereabouts?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Correct, where did you stash him?”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Kill me, and you’ll never find him. It should buy me a few hours to show you where he is.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I have no time to argue with you,” she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s right. There’s not a lot of air in his box.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She softened slightly, “I never believed you about Kizik, you having a connection to him. Not sure I do now.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Even after everything that happened?” he challenged.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Especially after everything that happened,” she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Salla Birdwing, is she away?” he asked, changing the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Birdwing is not on my list of problems either,” Dr. Tier replied. Timberwolf could tell by the exhaustion on her face that she was telling the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For a moment he considered staying in his cell and checking out of this game for good. Oddly, being confined within his own mind felt like the best part of freedom. But the next moment the door opened in front of him, and he found himself stepping through it. In the hall, two massive security officers were at his back.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dr. Tier walked beside him, staring straight ahead. She was right about the gravity of her problems but wrong that Timberwolf wasn’t one of them. He didn’t have a plan this very second, but Highland and any of its remaining lethal capability belonged to him, technically. An opportunity might arise on the world below to eliminate her.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They came to an airlock where technicians and rigged-up security teams boarded a drop-lifter. “After you,” Dr. Tier motioned for him to board the craft.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You first. I insist,” he countered.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1071d540","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap_02.vue
// module id = 81
// module chunks = 0